module.exports = __webpack_public_path__ + "static/media/Laguna logo-01.da49ee43.svg";